import { Alert, AlertTitle } from '@material-ui/lab';
import { useUserStore } from '@roc/feature-app-core';
import { isCivicUrl, isFacoUrl, isRocCapitalUrl } from '@roc/feature-utils';
import qr_code_ios_faco from '../assets/qr_code_ios_faco.png';
import qr_code_ios_civic from '../assets/qr_code_ios_civic.png';
import qr_code_android_faco from '../assets/qr_code_android_faco.png';
import qr_code_android_civic from '../assets/qr_code_android_civic.png';
import { AlertDialog } from '@roc/ui';
import { useState } from 'react';
import { Button } from '@material-ui/core';

export const MorganStanleyAlert = () => {

  return (
    <>
      <Alert severity="info">
        <AlertTitle>
          <strong>Snap Draw</strong>
        </AlertTitle>
        No snap draws available for draws greater than $100,000
      </Alert>
    </>
  );
};
